module.exports = __webpack_public_path__ + "img/BILDERAMME TEKNOLOGI.2c19c4d8.png";